import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "grid",
  "use": "grid-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"grid\"><path stroke=\"currentColor\" stroke-width=\".8\" d=\"M.734.733H5.49v4.756H.734zM8.511.733h4.756v12.533H8.511zM.734 8.51H5.49v4.756H.734z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol